import type { ReactNode, ReactElement } from 'react';
import { Children, cloneElement } from 'react';
import type {
  GoToPage,
  GoToNextPage,
  GoToPrevPage,
} from '@tmsw/powerups.config.page.provider';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';
import { usePageNavigation } from '../../hooks/usePageNavigation';

export interface AppPageProps {
  goToPage: GoToPage;
  goToPrevPage: GoToPrevPage;
  goToNextPage: GoToNextPage;
}

export interface AppPagesProps {
  children: ReactNode[];
}

export const AppPages = (props: AppPagesProps) => {
  const { currentPage, getPageKey } = usePageConfig();
  const pageKey = getPageKey(currentPage);
  const { goToPage, goToPrevPage, goToNextPage } = usePageNavigation();

  const children = Children.toArray(props.children) as ReactElement[];
  // .filter(
  //   (c) => getPageId(c.key.replace('.$', '')) !== null
  // );

  return (
    children
      .map((child) => {
        const pageProps = {
          ...child.props,
          goToNextPage,
          goToPrevPage,
          goToPage,
        };
        return cloneElement(child, pageProps);
      })
      .find((child) => child.key === `.$${pageKey}`) || null
  );
};
